import { toDate } from 'date-fns-tz/toDate';
import { toZonedTime } from 'date-fns-tz/toZonedTime';

import normalizeDate from './normalizeDate';

/**
 * Converts a date to a specific timezone.
 *
 * @param dateValue - The date to convert.
 * @param timeZone - TZ DB Format.
 * @returns A date object in the given timezone.
 */
export default function toTimeZone(dateValue: string | Date | number, timeZone: string) {
  const utcDate = toDate(normalizeDate(dateValue), { timeZone: 'Etc/UTC' });

  return toZonedTime(utcDate, timeZone);
}
